// extracted by mini-css-extract-plugin
export default {"SwitchContainer":"switch_SwitchContainer__H+Icb","checked":"switch_checked__UTGnk","SwitchRoot":"switch_SwitchRoot__Wz0o9","SwitchThumb":"switch_SwitchThumb__03klW"};